export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.75 2.5a3 3 0 00-3 3v14a3 3 0 003 3h8a3 3 0 003-3V8.086L14.164 2.5H8.75zm-1 3a1 1 0 011-1h4v5h5v10a1 1 0 01-1 1h-8a1 1 0 01-1-1v-14zm8.586 2L14.75 5.914V7.5h1.586z\" fill=\"#ff00cb\" fill-opacity=\".9\"/><path d=\"M15.75 18.5h-6v-2h6v2zM9.75 14.5h6v-2h-6v2z\" fill=\"#ff00cb\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "25",
    "height": "25",
    "viewBox": "0 0 25 25",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};